import { useTranslation } from "react-i18next";
import { ModalShell } from "@/shared/layout";
import { Modal } from "@/shared/ui";

export function ChangeVersionModal({
  open,
  versionName,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  versionName: string;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const { t } = useTranslation();
  const shortName = versionName.replace("v", "");
  return (
    <Modal
      id="change-version-modal"
      open={open}
      onOpenChange={(next) => {
        if (!next) onCancel();
      }}
      title="Layer version"
    >
      <ModalShell
        title="Layer version"
        description={t("saveChanges.confirmChanges").replace("[version]", shortName)}
        onClose={onCancel}
        footer={
          <>
            <button type="button" className="btn btn-ghost btn-sm" onClick={onCancel}>
              {t("dashboard.cancel")}
            </button>
            <button type="button" className="btn btn-primary btn-sm" onClick={onConfirm}>
              {t("layoutDesign.desktop.confirm")}
            </button>
          </>
        }
      >
        <p className="m-0 text-[12px] leading-5 text-muted">
          {t("saveChanges.nextVersion").replace("[version]", shortName)}
        </p>
      </ModalShell>
    </Modal>
  );
}
